module.exports = {
  small: "640px",
  medium: "768px",
  large: "1280px",
};
